import React, { useState, useEffect } from 'react';

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Check if iOS
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);

    // Listen for install prompt (Android/Chrome)
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Show iOS prompt after 3 seconds if not installed
    if (isIOSDevice) {
      const timer = setTimeout(() => {
        const hasSeenPrompt = localStorage.getItem('pwa-prompt-seen');
        if (!hasSeenPrompt) {
          setShowPrompt(true);
        }
      }, 3000);
      return () => clearTimeout(timer);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User ${outcome} the install prompt`);
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-seen', 'true');
  };

  if (isInstalled || !showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-slide-up" dir="rtl">
      <div className="bg-[#1e293b] border border-green-500/30 rounded-2xl p-4 shadow-xl">
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center flex-shrink-0">
            <img src="/icons/ritmoiq-r.png" alt="RitmoIQ" className="w-full h-full rounded-xl object-cover" />
          </div>
          
          {/* Content */}
          <div className="flex-1">
            <h3 className="text-white font-bold text-lg">התקן את RitmoIQ</h3>
            <p className="text-gray-400 text-sm mt-1">
              {isIOS 
                ? 'לחץ על "שתף" ואז "הוסף למסך הבית"'
                : 'הוסף לדף הבית לגישה מהירה'
              }
            </p>
            
            {/* Buttons */}
            <div className="flex gap-2 mt-3">
              {!isIOS && (
                <button
                  onClick={handleInstall}
                  className="px-4 py-2 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-xl font-medium text-sm hover:from-green-500 hover:to-green-400 transition-all"
                >
                  התקן עכשיו
                </button>
              )}
              <button
                onClick={handleDismiss}
                className="px-4 py-2 bg-white/10 text-gray-300 rounded-xl font-medium text-sm hover:bg-white/20 transition-all"
              >
                {isIOS ? 'הבנתי' : 'לא עכשיו'}
              </button>
            </div>
          </div>
          
          {/* Close button */}
          <button 
            onClick={handleDismiss}
            className="text-gray-500 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>
        
        {/* iOS Instructions */}
        {isIOS && (
          <div className="mt-4 pt-4 border-t border-white/10">
            <div className="flex items-center gap-3 text-sm text-gray-400">
              <span className="bg-white/10 rounded-lg px-2 py-1">1</span>
              <span>לחץ על</span>
              <span className="text-xl">⬆️</span>
              <span>למטה</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-400 mt-2">
              <span className="bg-white/10 rounded-lg px-2 py-1">2</span>
              <span>בחר "הוסף למסך הבית"</span>
              <span className="text-xl">➕</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InstallPrompt;
